import * as AddBasketOfferFailed from '@ori-events/add-basket-offer-failed';
import { HttpMethod } from '@ori/checkout-utils';
import { convertToCamelCase } from './convertToCamelCase';
import { getHttpRequestSettings } from './getHttpRequestSettings';
export async function addBasketOffer(url, params) {
  const response = await fetch(url, getHttpRequestSettings(params, HttpMethod.Post));
  const data = convertToCamelCase(await response.json());
  if (AddBasketOfferFailed.isAddBasketOfferErrorResponse(data)) {
    const event = new CustomEvent(AddBasketOfferFailed.Name, {
      detail: data
    });
    window.dispatchEvent(event);
    return false;
  }
  return data;
}
//# sourceMappingURL=addBasketOffer.js.map